import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {LoginResponse} from '../models/auth/login.response';
import {Credentials} from '../models/auth/credentials.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private LOGIN_URL: string = environment.BASE_URL + 'authenticate';

  constructor(private http: HttpClient) {
  }

  public login(credentials: Credentials): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(this.LOGIN_URL, credentials, {
      headers: {
        organization: credentials.organizationHandle
      }
    });
  }
}
